export default __webpack_public_path__ + "static/apple-watch-phone-3f0d5240977f599532b37119b6bd9098.png";